module.exports = __webpack_public_path__ + "static/media/Mohamed.eaed6ba2.jpg";